"use strict";
/**
 * 多语言 composable
 * 参考 quote-rank-v2 的实现方式
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LanguageId = exports.langTextMap = void 0;
exports.useI18n = useI18n;
const i18n_1 = require("./i18n");
Object.defineProperty(exports, "langTextMap", { enumerable: true, get: function () { return i18n_1.langTextMap; } });
Object.defineProperty(exports, "LanguageId", { enumerable: true, get: function () { return i18n_1.LanguageId; } });
const { useI18n: useI18nBase } = require('@fegobull/webapi').use;
/**
 * 使用多语言
 * @param languageId 语言 ID，默认英文
 * @returns 翻译函数 $t
 */
function useI18n(languageId = i18n_1.LanguageId.EN) {
    const $t = useI18nBase(i18n_1.langTextMap, languageId);
    return $t;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlSTE4bi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInVzZUkxOG4udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBOzs7R0FHRzs7O0FBV0gsMEJBR0M7QUFaRCxpQ0FBaUQ7QUFjeEMsNEZBZEEsa0JBQVcsT0FjQTtBQUFFLDJGQWRBLGlCQUFVLE9BY0E7QUFaaEMsTUFBTSxFQUFFLE9BQU8sRUFBRSxXQUFXLEVBQUUsR0FBRyxPQUFPLENBQUMsa0JBQWtCLENBQUMsQ0FBQyxHQUFHLENBQUM7QUFFakU7Ozs7R0FJRztBQUNILFNBQWdCLE9BQU8sQ0FBQyxhQUFxQixpQkFBVSxDQUFDLEVBQUU7SUFDdEQsTUFBTSxFQUFFLEdBQUcsV0FBVyxDQUFDLGtCQUFXLEVBQUUsVUFBVSxDQUFDLENBQUM7SUFDaEQsT0FBTyxFQUFFLENBQUM7QUFDZCxDQUFDIn0=